import React from 'react';
import { MenuItem } from 'react-pro-sidebar';
import ReactTooltip from 'react-tooltip';
import { v4 as uuid } from 'uuid';

const MenuItemWithTooltip = ({ id = `tooltip-${uuid()}`, children, ...props }) => {
  return (
    <>
      <ReactTooltip id={id} effect="solid" place="right" backgroundColor="#60a0ff" className="tooltip">
        {children}
      </ReactTooltip>
      <MenuItem {...props} data-tip data-for={id}>
        {children}
      </MenuItem>
    </>
  );
};

export default MenuItemWithTooltip;
